<img [src]="iconSrc" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" />
